import { render, staticRenderFns } from "./NotViewed.vue?vue&type=template&id=0344c06c&scoped=true&"
import script from "./NotViewed.vue?vue&type=script&lang=js&"
export * from "./NotViewed.vue?vue&type=script&lang=js&"
import style0 from "./NotViewed.vue?vue&type=style&index=0&id=0344c06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344c06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0344c06c')) {
      api.createRecord('0344c06c', component.options)
    } else {
      api.reload('0344c06c', component.options)
    }
    module.hot.accept("./NotViewed.vue?vue&type=template&id=0344c06c&scoped=true&", function () {
      api.rerender('0344c06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/NotViewed.vue"
export default component.exports